import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { 
  Container, 
  Typography, 
  Box,
  Paper,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
  Button
} from '@mui/material';
import welcomeImage from './img/welcome2.png';
import FloatingMenu from './components/FloatingMenu';

function ListaVisitantes() {
  const [visitantes, setVisitantes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const buscarVisitantes = async () => {
      try {
        const response = await axios.get('https://tibmacae.org.br/listar-visitantes.php');
        setVisitantes(response.data);
      } catch (error) {
        setError('Erro ao carregar lista de visitantes');
        console.error('Erro:', error);
      } finally {
        setLoading(false);
      }
    };

    buscarVisitantes();
  }, []);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundImage: `url(${welcomeImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 3,
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1
        }
      }}
    >
      <Container 
        maxWidth={false} 
        sx={{ 
          width: {
            xs: '100%', // 80% da largura em telas de celular
            sm: '100%'  // mantém 80% em telas maiores
          }, 
          position: 'relative', 
          zIndex: 2 
        }}
      >
        <Paper 
          elevation={3} 
          sx={{ 
            p: 4, 
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            backdropFilter: 'blur(8px)',
            borderRadius: 2,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
            border: '1px solid rgba(255, 255, 255, 0.2)'
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            <Typography 
              variant="h3" 
              component="h1" 
              sx={{ 
                fontFamily: "'Great Vibes', cursive",
                fontWeight: 700,
                color: '#FFFFFF',
                fontSize: {
                  xs: '1.5rem', // tamanho padrão para celular
                  sm: '4.2rem'  // dobro do tamanho para telas maiores que celular
                },
                textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                letterSpacing: '1px',
                textAlign: 'center',
                width: '100%',
                position: 'relative',
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  bottom: '-10px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: '100px',
                  height: '3px',
                  background: 'linear-gradient(90deg, transparent, #FFFFFF, transparent)',
                }
              }}
            >
              Sejam Bem Vindos
            </Typography>
            {/* <Button
              component={Link}
              to="/"
              variant="contained"
              color="primary"
              sx={{ 
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 'bold',
                position: 'absolute',
                right: 24,
                top: 24,
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                backdropFilter: 'blur(4px)',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.3)',
                }
              }}
            >
              Voltar
            </Button> */}
          </Box>

          {loading ? (
            <Box display="flex" justifyContent="center" p={3}>
              <CircularProgress sx={{ color: '#FFFFFF' }} />
            </Box>
          ) : error ? (
            <Typography color="error" align="center" sx={{ color: '#FF6B6B', textShadow: '1px 1px 2px rgba(0,0,0,0.5)' }}>{error}</Typography>
          ) : (
            <List sx={{ 
              maxHeight: '60vh', 
              overflow: 'auto',
              '&::-webkit-scrollbar': {
                width: '8px',
              },
              '&::-webkit-scrollbar-track': {
                background: 'rgba(255, 255, 255, 0.1)',
                borderRadius: '4px',
              },
              '&::-webkit-scrollbar-thumb': {
                background: 'rgba(255, 255, 255, 0.3)',
                borderRadius: '4px',
                '&:hover': {
                  background: 'rgba(255, 255, 255, 0.5)',
                },
              },
            }}>
              {visitantes.map((visitante, index) => (
                <ListItem 
                  key={index} 
                  divider
                  sx={{
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      transform: 'translateX(5px)',
                    },
                    padding: '16px 0',
                    borderBottom: '1px solid rgba(255, 255, 255, 0.2)'
                  }}
                >
                  <ListItemText
                    primary={
                      <Typography 
                        variant="h4" 
                        sx={{ 
                          fontFamily: "'Playfair Display', serif",
                          fontWeight: 700,
                          color: '#FFFFFF',
                          fontSize: {
                            xs: '1.1rem', // tamanho padrão para celular
                            sm: '2.2rem',
                            xl: '5.2rem',  // dobro do tamanho para telas maiores que celular
                            xxl:'8.2rem'
                          },
                          letterSpacing: '0.5px',
                          marginBottom: '4px',
                          textShadow: '1px 1px 3px rgba(0,0,0,0.5)'
                        }}
                      >
                        {visitante.nome}
                      </Typography>
                    }
                    secondary={
                      <Typography 
                        variant="body1" 
                        sx={{ 
                          fontFamily: "'Dancing Script', cursive",
                          fontSize: '1.2rem',
  '@media (min-width:600px)': {
    fontSize: '1.5rem',
  },
                          // fontSize: {
                          //   xs: '1.1rem', // tamanho padrão para celular
                          //   sm: '2.2rem'  // dobro do tamanho para telas maiores que celular
                          // },
                          color: 'rgba(255, 255, 255, 0.9)',
                          marginLeft: '8px',
                          textShadow: '1px 1px 2px rgba(0,0,0,0.5)'
                        }}
                      >
                        {/* Email: {visitante.email} | Telefone: {visitante.telefone} | Data: {visitante.data_visita} */}
                      </Typography>
                    }
                  />
                </ListItem>
              ))}
            </List>
          )}
        </Paper>
      </Container>
      {/* <Container maxWidth="md" sx={{ width: '', position: 'relative', zIndex: 2 }}>
        <FloatingMenu />
      </Container> */}
    </Box>
  );
}

export default ListaVisitantes;